import { legacyApi } from '@/lib/legacy-api.js';

/** Raised when `alipay_page2` answers with anything but the account record. */
export class AccountRequestError extends Error {
  constructor(
    readonly endpoint: string,
    readonly code: string,
    message: string,
  ) {
    super(`${endpoint} failed (${code}): ${message}`);
    this.name = 'AccountRequestError';
  }
}

/**
 * The account record behind the profile screen.
 *
 * `alipay_page2` — named for the Alipay top-up page it prefills, which is why the document files
 * it under 充值 rather than under anything to do with an account. It is nonetheless the only
 * endpoint in the API that returns the customer's own record: 99 fields, against the four the
 * document prints.
 *
 * Returned raw. `normaliseAccountProfile` decides which of those 99 the app is allowed to read,
 * and that decision belongs in the tested shared layer, not here.
 */
export async function fetchAccountRecord(): Promise<unknown> {
  const result = await legacyApi.call<unknown>('alipay_page2');

  if (!result.ok) throw new AccountRequestError('alipay_page2', result.code, result.message);

  return result.data;
}
